/** @format */

import React from "react";
import TextField from "@mui/material/TextField";

function MultilineTextInput({value, setValue, label, name, rows=4}) {
  const maxLen = 250;
  return (
    <>
      <TextField
        id={name}
        label={label}
        name={name}
        multiline
        rows={rows}
        variant="filled"
        value={value}
        onChange={e => setValue(e.target.value)}
        error={value?.length >= maxLen}
        helperText={250 - value.length + " Characters Remaining of 250 Characters"}
        inputProps={
            {maxLength: maxLen}
        }
        sx={{mt: 2}}
      />
    </>
  );
}

export default MultilineTextInput;
